<template>
  <LayoutSearchFieldVertical>
    <div class="search-field-coordinates">
      <form class="search-keyword-field" @submit.prevent="startMap">
        <span>{{ lss('緯度', 'Latitude') }}</span>
        <input
          class="jps-input jps-keyword-input input-number"
          type="number"
          v-model="lat"
          step="0.0000001"
        />
        <span>{{ lss('経度', 'Longitude') }}</span>
        <input
          class="jps-input jps-keyword-input input-number"
          type="number"
          step="0.0000001"
          v-model="lon"
        />
        <span>{{ lss('半径', '') }}</span>
        <input
          class="jps-input jps-keyword-input input-number radius"
          type="number"
          min="0"
          v-model="d"
        />
        <span>{{ lss('km', 'km radius') }}</span>
      </form>

      <button
        class="jps-round-button jps-slim start-map-button jps-grey"
        @click="startMap()"
      >
        {{ lss('地図で検索', 'Search by map') }}
      </button>
    </div>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { lss } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const lat: Ref<number> = ref(35.3622222)
const lon: Ref<number> = ref(138.7313889)
const d: Ref<number> = ref(100)

const startMap = () => {
  console.info('start map', lat.value, lon.value)
  props.ss.state.sort = ['geo:' + props.field.key]
  props.ss.state.size = 500
  props.ss.setGeo(props.field.key, {
    lat: lat.value,
    lon: lon.value,
    distance: d.value + 'km',
  })
}
</script>

<style lang="scss" scoped>
.search-field-coordinates {
  display: flex;

  .search-keyword-field {
    span {
      min-width: fit-content;
      font-size: 0.875rem;
    }
    .input-number {
      width: 9rem;
    }
    .radius {
      width: 5rem;
    }
    height: 2rem;
    align-items: center;
    max-width: none;
  }
  .jps-round-button {
    margin-left: 0.75rem;
  }
}
</style>
